import { observer } from 'mobx-react-lite'
import React from 'react'
import { ContainerHeader, type IContainerHeaderProps } from 'shared/ui'
import { useChatbotLayoutContext } from 'pages/chatbot/context/chatbotLayoutContext'
import styles from './styles.module.scss'

type IAgentEditHeaderProps = Pick<
  IContainerHeaderProps,
  'rightTitleContent' | 'actionsProps' | 'customTitle' | 'actionsGap' | 'actions'
>

export const AgentEditHeader = observer((props: IAgentEditHeaderProps) => {
  const { pageLayoutStore } = useChatbotLayoutContext()
  const { titleIconProps, headerMenuTooltipIconProps, headerMenuIconAction } = pageLayoutStore
  const { rightTitleContent } = props
  return (
    <ContainerHeader
      style={{ height: '100%', minHeight: 'unset', padding: '0 20px' }}
      titleVariant='heading-md'
      titleIconProps={titleIconProps}
      actionIconTooltipProps={headerMenuTooltipIconProps}
      titleIconAction={headerMenuIconAction}
      isBorderBottom
      isBorderRight
      isTitleDivider
      {...props}
      rightTitleContent={
        rightTitleContent && <div className={styles.rightTitleContent}>{rightTitleContent}</div>
      }
    />
  )
})
